export enum OnboardingAction {
	SceneDrag = 'SceneDrag',
	SceneScroll = 'SceneScroll',
	LobeAdd = 'LobeAdd',
	LobeClickAndDrag = 'LobeClickAndDrag',
	LobeMultiSelect = 'LobeMultiSelect',
	LobeSnap = 'LobeSnap'
}
